var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "current"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3935 11.7595C11.912 12.0237 12.4921 12.3192 13.2463 12.3192C14.6826 12.3192 16.9169 10.5637 17.2361 8.80815C16.8105 8.96775 15.7679 9.28693 15.0018 9.28693C14.2358 9.28693 13.4059 8.64856 13.0867 8.32938C12.7675 7.69101 11.6823 6.41428 9.89489 6.41428C8.10746 6.41428 7.44781 7.15904 7.34142 7.53142V12.6384C8.32371 11.775 8.90689 11.4993 10.0545 11.3616C10.506 11.3074 10.9245 11.5207 11.3935 11.7595ZM6.3041 6.89305C5.90747 6.89305 5.58594 7.21459 5.58594 7.61122V16.7877L7.02226 17.5857V7.61121C7.02226 7.21458 6.70073 6.89305 6.3041 6.89305Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagIcon);
export default __webpack_public_path__ + "static/media/flag-icon.71fb10f7e44acb2b91857d0b1935ea01.svg";
export { ForwardRef as ReactComponent };